// extracted by mini-css-extract-plugin
export var saHomeImageFaqSection = "saHomeImageFaq-module--saHomeImageFaqSection--2h7T4";
export var saHomeImageFaqRows = "saHomeImageFaq-module--saHomeImageFaqRows--2Q8ce";
export var saHomeImageFaqItem = "saHomeImageFaq-module--saHomeImageFaqItem--1coWb";
export var saHomeImageFaqItemImage = "saHomeImageFaq-module--saHomeImageFaqItemImage--P3CEm";
export var saHomeImageFaqItemIcon = "saHomeImageFaq-module--saHomeImageFaqItemIcon--F4tla";
export var saHomeImageFaqItemTextblock = "saHomeImageFaq-module--saHomeImageFaqItemTextblock--1RxvX";
export var saHomeImageFaqItemTitleContainer = "saHomeImageFaq-module--saHomeImageFaqItemTitleContainer--3cGch";
export var saHomeImageFaqItemTitle = "saHomeImageFaq-module--saHomeImageFaqItemTitle--2uOxb";
export var saHomeImageFaqItemText = "saHomeImageFaq-module--saHomeImageFaqItemText--1Qglq";
export var saFaqListItem = "saHomeImageFaq-module--saFaqListItem--201zu";
export var saQ = "saHomeImageFaq-module--saQ--26ZUa";
export var saA = "saHomeImageFaq-module--saA--bcO9s";
export var saHomeImageFaqBtn = "saHomeImageFaq-module--saHomeImageFaqBtn--1FeRa";